import { render, staticRenderFns } from "./LomTrainingQuestionCreate.vue?vue&type=template&id=385b2fb0"
import script from "./LomTrainingQuestionCreate.vue?vue&type=script&lang=js"
export * from "./LomTrainingQuestionCreate.vue?vue&type=script&lang=js"
import style0 from "./LomTrainingQuestionCreate.vue?vue&type=style&index=0&id=385b2fb0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports